
<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>
                <h3 class="inter-titre" style="text-align: left">Agenda</h3>
                <div class="AgendaSdFDiv">
                    <iframe src="https://calendar.google.com/calendar/u/0/embed?src=gku4k11npjotglk710acut19es@group.calendar.google.com&ctz=Europe/Paris" class="" style="border: 0" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>
                </div>
                <h3 class="inter-titre" style="text-align: left">Manifestations à venir</h3>
                <section class="Section-pages section-pages-cartes">
                    <div class="carte-conseiller" v-if="listeActualitesFuture.length == 0">
                        <div>
                            <img src="static/css/img/CommuneQuenne.jpg" class="portrait-conseiller">
                        </div>

                        <section class="contenu-carte">
                            <h5>Aucune actualité à venir</h5>
                        </section>
                    </div>
                    <router-link :to="{name: 'Publication', params: {id : actualite.id}}" class="carte-conseiller" v-for="actualite in listeActualitesFuture" :key="actualite.id">
                        <div v-if="actualite.image != ''">
                            <img :src="actualite.image" class="portrait-conseiller">
                        </div>

                        <section class="contenu-carte">
                            <h5>{{actualite.titre}}</h5>
                            <i>{{actualite.date}}</i>
                            <br>
                            <p v-html="actualite.textereduit"></p>
                        </section>
                    </router-link>
                </section>
               
                <h2 class="inter-titre">Actualités des 12 derniers mois</h2>

                <section class="Section-pages section-pages-cartes">
                    <router-link :to="{name: 'Publication', params: {id : actualite.id}}" class="carte-conseiller" v-for="actualite in listeActualitesAnte" :key="actualite.id">
                        <div v-if="actualite.image != ''">
                            <img :src="actualite.image" class="portrait-conseiller">
                        </div>

                        <section class="contenu-carte">
                            <h5>{{actualite.titre}}</h5>
                            <i>{{actualite.date}} <br> </i>
                            <p v-html="actualite.textereduit"></p>
                        </section>
                    </router-link>
                </section>
            </section>
        </div>
    </div>
</template>

<script>


import param from '@/param/param'

export default {
    name: 'Publications',
    data () {
        return{
            listeQuenneInfos:{
                id: 0,
                date: null,
                fichier_pdf: null
            },
            listeActualites:{
                id: 0,
                titre: null,
                texte: null,
                date: null,
                date_comparaison: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                image: null,
                album: 0
            },
            listeActualitesAnte:{
                id: 0,
                titre: null,
                texte: null,
                date: null,
                date_comparaison: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                image: null,
                album: 0
            },
            listeEchos:{
                id: 0,
                type: '',
                fichier_pdf: null,
                date: null,
            },
            listeQI:{
                id: 0,
                type: '',
                fichier_pdf: null,
                date: null,
            },
            ActuFilterByDate: {},
            openFiltres: true,
            keyword: '',
            AlbumSelected: 0,
            dateMin: null,
            dateMax : null,
            dateAncienneNum: null,
            dateAncienneNumUn: null,
            range: 0,
            OrderActu: 'DateDecroissant',
            AlbumSelected: 0,
            CetAlbum: 0,
            vieilleActus: 0,
            NbrActus: 0,
            listeActualitesFuture: [],
            imageCourante: 'https://mairie-quenne./wp-content/uploads/2022/04/Quenne_C_FT.png',
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }

    }, 

    created(){
        var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.DateMaxEN = annee+'-'+moisnumerique[moi]+'-'+j;
        this.jourInfini = mois[moi];
        this.dateAncienneNumUn = annee-1+'-'+moisnumerique[moi]+'-'+j;
        this.dateAncienneNum = annee-3+'-'+moisnumerique[moi]+'-'+j;
        this.dateFutureNum = this.anneeMoinsUn+'-'+moisnumerique[moi]+'-'+j;
        console.log(this.dateAncienneNum)

        this.dateMin = this.dateAncienneNum;
        this.dateMax = this.dateFutureNum


        axios.get(param.host+'quenneInfo/v1/listeQuenneInfos')
        .then(response =>{
            this.listeQuenneInfos = response.data;
            let Echos = new Array;
            let QI = new Array;
            let r = 0;
            let s = 0;
            for(var k = 0; this.listeQuenneInfos.length > k; k++){
                this.dateSplit = this.listeQuenneInfos[k].date.split('/');
                this.listeQuenneInfos[k].date_comparaison = this.dateSplit[2]+'-'+this.dateSplit[1]+'-'+this.dateSplit[0];

                if(this.listeQuenneInfos[k].type == 'Échos de Quenne' && this.listeQuenneInfos[k].date_comparaison >= this.dateAncienneNumUn){
                    Echos[r] = this.listeQuenneInfos[k];
                    r++;
                }if(this.listeQuenneInfos[k].type == 'Quenne informations' && this.listeQuenneInfos[k].date_comparaison >= this.dateAncienneNumUn){
                    QI[s] = this.listeQuenneInfos[k];
                    s++;
                }

                this.listeEchos = Echos;
                this.listeQI = QI;
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'actualite/v1/listeActualites')
        .then(response =>{
            this.listeActualites = response.data;
            console.log(this.listeActualites)
            let actu = new Array
            let actuAnte = new Array
            let actuArchive = new Array
            let j = 0
            let l = 0
            let p = 0

            for(var k = 0; this.listeActualites.length > k; k++){
                this.dateSplit = this.listeActualites[k].date.split('/');
                this.listeActualites[k].date_comparaison = this.dateSplit[2]+'-'+this.dateSplit[1]+'-'+this.dateSplit[0];

                if(this.listeActualites[k].date_comparaison >= this.DateMaxEN){
                    actu[j] = this.listeActualites[k]
                    j++;
                }if(this.listeActualites[k].date_comparaison <= this.DateMaxEN && this.listeActualites[k].date_comparaison >= this.dateAncienneNumUn){
                    actuAnte[l] = this.listeActualites[k]
                    l++;
                }else{
                    actuArchive[p] = this.listeActualites[k]
                    p++;
                }

            }
            this.listeActualitesFuture = actu;
            this.listeActualitesAnte = actuAnte;
            this.listeActualitesArchive = actuArchive;

            function compare(a, b){
                if(a.date_comparaison < b.date_comparaison) return -1
                if(a.date_comparaison > b.date_comparaison) return 1
                return 0
            }

            this.listeActualitesFuture.sort(compare)

             function compare(a, b){
                if(a.date_comparaison > b.date_comparaison) return -1
                if(a.date_comparaison < b.date_comparaison) return 1
                return 0
            }

            this.listeActualitesAnte.sort(compare)

        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Agenda'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

    computed:{
        filterListPubliAnte: function(){
            return this.filterActuByRange(this.filterListByKeyword(this.ActusOrderByName))
        },

        ActusOrderByName: function(){
            if(this.OrderActu == 'NomCroissant'){
                function compare(a, b){
                    if(a.slug < b.slug) return -1
                    if(a.slug > b.slug) return 1
                    return 0
                }
                return this.listeActualitesAnte.sort(compare)
            }if(this.OrderActu =='NomDecroissant'){
                function compare(a, b){
                    if(a.slug > b.slug) return -1
                    if(a.slug < b.slug) return 1
                    return 0
                }
                return this.listeActualitesAnte.sort(compare)
            }if(this.OrderActu == "DateDecroissant"){
                function compare(a, b){
                    if(a.date_comparaison > b.date_comparaison) return -1
                    if(a.date_comparaison < b.date_comparaison) return 1
                    return 0
                }
                return this.listeActualitesAnte.sort(compare)
            }if(this.OrderActu == "DateCroissant"){
                function compare(a, b){
                    if(a.date_comparaison < b.date_comparaison) return -1
                    if(a.date_comparaison > b.date_comparaison) return 1
                    return 0
                }
                return this.listeActualitesAnte.sort(compare)
            }else{
                return this.listeActualitesAnte
            }
        },

    },

    methods: {
        filterListByKeyword: function(listeActualites){
            return listeActualites.filter(function(actu){
                return (
                    actu.titre.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0
                    ? actu
                    : ''
                )
            }.bind(this))
        },

        ReiniFiltres: function(){
            this.keyword = '';
            this.dateMin = this.dateAncienneNum;
            this.dateMax = this.dateFutureNum;
            this.OrderActu = 'DateDecroissant';
        },

        filterActuByRange: function(listeActualites){
            return listeActualites.filter(actu => (
                actu.date_comparaison >= this.dateMin && actu.date_comparaison <= this.dateMax)
                ? actu
                : ''
            )
        },
    },

    filters : {
        liveSubstr: function(string, nb){
            return string.substring(0,nb) + '...';
        },
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Agenda.vue